export default __webpack_public_path__ + "static/media/pointer.bf640cce.svg";